@if (safePdfUrl()) {
<div
  class="w-full rounded-lg shadow-lg overflow-hidden"
  [style.height]="height()"
  [style.width]="width()"
  [class]="customClass()"
  (contextmenu)="$event.preventDefault()"
>
  <iframe
    #pdfFrame
    [src]="safePdfUrl()"
    class="w-full h-full border-0"
  ></iframe>
</div>
} @else {
<div
  class="flex items-center justify-center h-64 text-gray-500 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300"
>
  <div class="text-center">
    <i class="pi pi-file-pdf text-6xl mb-4 block text-gray-400"></i>
    <span class="text-lg font-medium">No PDF to display</span>
  </div>
</div>
}
